import SpriteSymbol from "../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "music-icon",
  "use": "music-icon-usage",
  "viewBox": "0 0 114 111",
  "content": "<symbol viewBox=\"0 0 114 111\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"music-icon\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M98 0L29 19V23V43V84.1259C25.9581 82.1661 22.1425 81 18 81C8.05887 81 0 87.7157 0 96C0 104.284 8.05887 111 18 111C27.9411 111 36 104.284 36 96V41.0725L91 25.9275V64.1259C87.9581 62.1661 84.1425 61 80 61C70.0589 61 62 67.7157 62 76C62 84.2843 70.0589 91 80 91C89.9411 91 98 84.2843 98 76V24V4V0Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol